<ng-container *ngFor="let menuItem of menuList">

    <ng-container *ngIf="!menuItem.children.length">
        <button *ngIf="menuItem.route != null" #button mat-button [routerLink]="menuItem.route">
            <mat-icon class="icon">{{menuItem.icon}}</mat-icon>
            <span class="text-holder">{{menuItem.label}}</span>
        </button>
        <button *ngIf="menuItem.href != null" #button mat-button (click)="gotoWindow(menuItem.href)">
            <mat-icon class="icon">{{menuItem.icon}}</mat-icon>
            <span class="text-holder">{{menuItem.label}}</span>
        </button>
    </ng-container>
    <ng-container *ngIf="menuItem.children.length">
      <button mat-button [matMenuTriggerFor]="levelOne" #levelOneTrigger="matMenuTrigger" [matMenuTriggerData]="menuItem.id" (mouseenter)="buttonEnter(levelOneTrigger)" (mouseleave)="buttonLeave(levelOneTrigger, $event)" style="z-index:1000">
            <mat-icon class="icon">{{menuItem.icon}}</mat-icon>
            <span>{{menuItem.label}}
              <i class="fa fa-chevron-down"></i>
            </span>
      </button>     
  
      <mat-menu class="matmenuclass" #levelOne="matMenu" direction="down" yPosition="below">
            <span (mouseenter)="menuenter(levelOneTrigger)" (mouseleave)="menuLeave(levelOneTrigger)">
                    <ng-container *ngFor="let childL1 of menuItem.children">
                <li mat-menu-item *ngIf="!childL1.children.length" class="limenuitem">
                    <a *ngIf="childL1.route != null" [routerLink]="childL1.route" [title]="childL1.title">
                            <mat-icon class="icon">{{childL1.icon}}</mat-icon>
                            {{childL1.label}}
                    </a>
                    <a *ngIf="childL1.href != null" [href]="childL1.href" [target]="childL1.behavior" [title]="childL1.title">
                            <mat-icon class="icon">{{childL1.icon}}</mat-icon>
                            {{childL1.label}}
                    </a>

                    <!-- working with url parameter visible
                    <a *ngIf="childL1.route2 != null" [routerLink]="['viewcomp', childL1.route2 ]">
                        <mat-icon class="icon">{{childL1.icon2}}</mat-icon>
                        {{childL1.label2}}
                    </a>
                    -->

                    <a *ngIf="childL1.route2 != null" routerLink="viewcomp" [state]="{ url: childL1.route2 }" [title]="childL1.title2">
                            <mat-icon class="icon" style="margin-left: 32px; ">{{childL1.icon2}}</mat-icon>
                            {{childL1.label2}}
                    </a>
                    <a *ngIf="childL1.href2 != null" [href]="childL1.href2" [target]="childL1.behavior2" [title]="childL1.title2">
                            <mat-icon class="icon" style="margin-left: 32px; ">{{childL1.icon2}}</mat-icon>
                            {{childL1.label2}}
                    </a>
                </li>
    
            <ng-container *ngIf="childL1.children.length">
                  <li mat-menu-item #levelTwoTrigger="matMenuTrigger" [matMenuTriggerFor]="levelTwo">
                        <mat-icon class="icon">{{childL1.icon}}</mat-icon>
                        <span>{{childL1.label}}</span>
                  </li>
  
                  <mat-menu class="matmenuclass" #levelTwo="matMenu">
                      <span (mouseenter)="menu2enter(levelOneTrigger)" (mouseleave)="menu2Leave(levelOneTrigger)">
                          <ng-container *ngFor="let childL2 of childL1.children">
                            <li mat-menu-item *ngIf="!childL2.children.length" class="limenuitem">
                                <a *ngIf="childL2.route != null" [routerLink]="childL2.route" [title]="childL2.title">
                                        <mat-icon class="icon">{{childL2.icon}}</mat-icon>
                                        {{childL2.label}}
                                </a>
                                <a *ngIf="childL2.href != null" [href]="childL2.href" [target]="childL2.behavior" [title]="childL2.title">
                                        <mat-icon class="icon">{{childL2.icon}}</mat-icon>
                                        {{childL2.label}}
                                </a>
                                <a *ngIf="childL2.route2 != null" routerLink="viewcomp" [state]="{ url: childL2.route2 }" [title]="childL2.title2">
                                        <mat-icon class="icon" style="margin-left: 32px; ">{{childL2.icon2}}</mat-icon>
                                        {{childL2.label2}}
                                </a>
                                <a *ngIf="childL2.href2 != null" [href]="childL2.href2" [target]="childL2.behavior2" [title]="childL2.title2">
                                    <mat-icon class="icon" style="margin-left: 32px; ">{{childL2.icon2}}</mat-icon>
                                    {{childL2.label2}}
                                </a>
                            </li>
  
                              <ng-container *ngIf="childL2.children.length">
                                  <li mat-menu-item #levelThreeTrigger="matMenuTrigger" [matMenuTriggerFor]="levelThree">
                                        <mat-icon class="icon">{{childL2.icon}}</mat-icon>
                                        <span>{{childL2.label}}</span>
                                  </li>
  
                                  <mat-menu class="matmenuclass" #levelThree="matMenu">
                                      <span (mouseenter)="menu3enter(levelOneTrigger)" (mouseleave)="menu3Leave(levelOneTrigger)">
                                          <ng-container *ngFor="let childL3 of childL2.children">
                                                <li mat-menu-item class="limenuitem">
                                                    <a *ngIf="childL3.route != null" [routerLink]="childL3.route" [title]="childL3.title">
                                                            <mat-icon class="icon">{{childL3.icon}}</mat-icon>
                                                            {{childL3.label}}
                                                    </a>
                                                    <a *ngIf="childL3.href != null" [href]="childL3.href" [target]="childL3.behavior" [title]="childL3.title">
                                                            <mat-icon class="icon">{{childL3.icon}}</mat-icon>
                                                            {{childL3.label}}
                                                    </a>
                                                    <a *ngIf="childL3.route2 != null" routerLink="viewcomp" [state]="{ url: childL3.route2 }" [title]="childL3.title2">
                                                            <mat-icon class="icon" style="margin-left: 32px; ">{{childL3.icon2}}</mat-icon>
                                                            {{childL3.label2}}
                                                    </a>
                                                    <a *ngIf="childL3.href2 != null" [href]="childL3.href2" [target]="childL3.behavior2" [title]="childL3.title2">
                                                            <mat-icon class="icon" style="margin-left: 32px; ">{{childL3.icon2}}</mat-icon>
                                                            {{childL3.label2}}
                                                    </a>
                                                </li>
                                          </ng-container>
                                      </span>
                                  </mat-menu>
                              </ng-container>
                          
                          
                          
                          </ng-container>
                      </span>
                  </mat-menu>
              </ng-container>
          </ng-container>
        </span>
      </mat-menu>
    </ng-container>
  
  </ng-container>